import { jsProvider as Provider } from './Features.bs'

export default Provider
